import { fetchPost, fetchGet, fetchPut, fetchDelete } from '../services/Apiservice'
import { productUploader as productFormUploader } from './formuploader/product'

/**
 * Get product list from API
 */
export const productList = (data) => {
    return fetchGet('/products', data)
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Create new product from API
 */
export const productCreate = (data) => {
    const formData = productFormUploader(data);

    return fetchPost('/products', formData)
    .then((res) => {
        console.log('test');
        console.log(res);
        return res
    })
    .catch((res) => {
        console.log('test3333');
        console.log(res);
        throw res
    })
}

/**
 * Edit product details from API
 */
export const productEdit = (id, data) => {
    const formData = productFormUploader(data)

    return fetchPost(`/products/${id}/update`, formData)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Get product details from API
 */
export const productDetail = (id) => {
    return fetchGet(`/products/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Delete product data through API
 */
export const productDelete = (id) => {
    return fetchDelete(`/products/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Toggle product status through API
 */
export const productToggleStatus = (id) => {
    return fetchPost(`/products/${id}/toggle-status`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * product Stock Quandity Update through API
 */
export const productUpdateStock = (id, payload) => {
    return fetchPost(`/products/${id}/stock`, payload)
        .then(res => res)
        .catch(err => { throw err })
}

// Backward compatibility export
export const productsApi = {
    getAll: productList,
    getById: productDetail,
    create: productCreate,
    update: productEdit,
    delete: productDelete,
    stock: productUpdateStock,
    toggleStatus: productToggleStatus,
}
